import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LocationGroup } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchLocationGroups($where: LocationGroupWhereInput, $limit: Int, $offset: Int) {
    locationsGroups(
      where: $where
      orderBy: name_asc
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-location-groups-input',
  templateUrl: './fc-location-groups-input.component.html',
  styleUrls: ['./fc-location-groups-input.component.scss']
})
export class FcLocationGroupsInputComponent {

  @Input()
  public control: FormControl;

  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService, private apollo: Apollo) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string, limit: number, offset: number): Promise<LocationGroup[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            name_contains: searchTerm,
            archived: false
          },
          limit: limit,
          offset: offset
        },
      })
      .toPromise()
      .then((result) => result.data['locationsGroups']['items'])
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: LocationGroup): string {
    return value && value.name;
  }

}
